/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
export enum ManagedAuthType {
  None = 0,
  MidasCloud = 1,
  ActiveDirectory = 2,
  Imprivata = 3,
}

export interface ManagedAuth {
  id: number;
  name: string | null;
  description: string | null;
  type: ManagedAuthType;
  ipAddress: string | null;
  port: string | null;
  default: boolean | null;
  createdAt: string;
  updatedAt: string | null;
}
